import styled, { css } from 'styled-components'

type IButton = {
  variant: 'primary' | 'secondary' | 'danger' | 'success' | 'info' | 'brand'
  block?: string
  size?: 'small' | 'large' | 'medium'
  margin?: string
}

const blockStyle = css`
  display: flex;
  width: 100%;
`

const sizes = {
  small: css`
    padding: 6px 10px;
    min-height: 30px;
    font-size: 0.85em;

    svg {
      width: 18px;
    }
  `,
  medium: css`
    padding: 8px 14px;
    min-height: 40px;
    font-size: 0.95em;

    svg {
      width: 22px;
    }
  `,
  large: css`
    padding: 12px 16px;
    min-height: 50px;
    font-size: 1.125em;

    svg {
      width: 24px;
    }
  `,
}

export const Button = styled.button<IButton>`
  background-color: ${(props) =>
    props.theme.button[props.variant].bgColor || '#1976d2'};
  color: ${(props) => props.theme.button[props.variant].textColor || '#1976d2'};
  border-radius: ${(props) => props.theme.border.radius || '6px'};

  ${(props) => props.block && blockStyle};
  ${(props) => (props.size ? sizes[props.size] : sizes['medium'])};

  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-align: center;
  border: 0;
  cursor: pointer;
  transition: all 0.2s ease-in;
  margin: ${(props) => (props.margin ? props.margin : '0px')};

  &.inactive {
    cursor: default;
    pointer-events: none;
  }

  svg {
    fill: currentColor;
  }

  svg:not(:only-child) {
    margin-right: 4px;
  }

  &:not(.inactive):hover,
  &:not(.inactive):focus {
    background-color: ${(props) =>
      props.theme.button[props.variant].hover || '#1565c0'};
  }

  &:disabled {
    opacity: 0.65;
    pointer-events: none;
  }
`

export const CardBlockButton = styled.button`
  color: ${(props) => props.theme.body.textColor};
  border-radius: ${(props) => props.theme.border.radius || '6px'};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  padding: 12px;
  width: 190px;
  height: 140px;
  cursor: pointer;
  border: 0;
  outline: 0;
  font-size: 1em;
  word-break: break-all;

  &.inactive,
  &:disabled {
    opacity: 0.65;
    pointer-events: none;
  }

  svg {
    width: 1.125em;
  }

  &:not(.inactive):focus {
    border-color: ${(props) => props.theme.button.info.hover};
  }
  &:not(.inactive):hover {
    background-color: ${(props) => props.theme.button.info.bgColor};
  }
`

export const CardButton = styled.button`
  color: ${(props) => props.theme.body.textColor};
  border-radius: ${(props) => props.theme.border.radius || '6px'};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  cursor: pointer;
  border: 0;
  outline: 0;
  font-size: 1em;
  padding: 14px 18px;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);

  &.inactive,
  &:disabled {
    opacity: 0.65;
    pointer-events: none;
  }

  svg {
    width: 1.125em;
  }

  &:not(.inactive):not(:disabled):focus {
    border-color: ${(props) => props.theme.button.info.hover};
  }

  &:not(.inactive):not(:disabled):hover {
    background-color: ${(props) => props.theme.button.info.bgColor};
  }
`

type IBigButton = {
  center?: boolean
}

export const BigButton = styled.button<IBigButton>`
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px 24px;
  cursor: pointer;
  border: 0;
  outline: 0;
  font-size: 1em;
  background-color: transparent;
  color: #828e97;
  margin: ${(props) => (props.center ? '0 auto' : '0')};

  &:hover {
    color: ${(props) => props.theme.body.textColor};
  }
`
